(function(module) {
    'use strict';

    function CustomAppTemplateCtrl(WS, $scope, $timeout, $state, AppTemplate, $stateParams, Store, $mdDialog, ngCopy, Upload, $http, envService, App, appStoreCustomAppSavePayload) {
        this.SLS_URI = envService.read('SLS_URI');

        this.getAppTemplate = (appTemplateId) => {
            if ($stateParams.appTemplate) {
                const deferred = $q.defer();
                $timeout(() => {
                    return deferred.resolve($stateParams.appTemplate);
                });
                return deferred.promise;
            } else {
                return AppTemplate.findById({ id: appTemplateId }).$promise;
            }
        };

        this.$onInit = () => {

            this.records = [];
            this.mode = $stateParams.route;
            this.orientation = 'landscape';
            this.hideButton = false;
            this.showUpload = false;

            if (this.mode === 'add') {
                this.appTemplate = {
                    live: true,
                    realm: 'custom',
                    type: 'custom',
                    styles: {
                        iconBackground: '#0a7dff',
                        iconColor: '#FFFFFF',
                        icon1: 'fa-code',
                    },
                };
            }

            if (this.mode === 'edit') {
                this
                    .getAppTemplate($stateParams.appTemplateId)
                    .then((appTemplate) => {
                        this.appTemplate = Store.setSingleModelData('appTemplates', appTemplate.id, appTemplate);
                        if (this.appTemplate.id && !this.appTemplate.version) {
                            this.showUpload = true;
                        }
                        this.addSubscription(this.appTemplate);
                    });
            }

            this.appSourceTypeSelect = [
                { id: 'upload', label: 'UPLOAD' },
                { id: 'cli', label: 'CLI' },
            ];
        };

        this.addSubscription = ({ id }) => {
            const recordName = `appTemplate:${id}`;
            WS.record.getRecord(recordName).whenReady((record) => {
                record.subscribe(({ version, fields, events, meta }) => {
                    if (version) this.appTemplate.version = version;
                    if (fields) this.appTemplate.fields = fields;
                    if (events) this.appTemplate.events = events;
                    if (meta) this.appTemplate.meta = meta;
                    if (version || fields || events || meta) {
                        if (!$scope.$$phase) {
                            $timeout(() => {
                                $scope.$apply();
                            });
                        }
                    }
                });
                this.records.push(record);
            });
        };

        this.$onDestroy = () => {
            _.each(this.records, (record) => {
                record.unsubscribe();
                record.discard();
            });
        };

        this.isEmpty = (obj) => {
            return _.isEmpty(obj);
        };
        this.uploadNewSourceCode = () => {
            // this.showUpload = !this.showUpload;
            this.findAppsUsingAppTemplateId(this.appTemplate.id)
                .then((response) => {
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;
                    const appsUsedByTemplateCount = response && response.length;

                    //app exists
                    if (appsUsedByTemplateCount > 0) {
                        modalTitle = 'On upload any changes made in the app source code will be also automatically applied to:';

                        itemCount1 = appsUsedByTemplateCount > 0 ? `${appsUsedByTemplateCount + ' of your apps'}` : null;

                        modalConfirmationText = 'and ultimately to any groups, playlists or displays (if applicable).';
                        modalConfirmText = 'Upload new source code';
                        modalCancelText = 'Cancel';
                        const modalTypeOverride = 'information';

                        confirmActionFunc = () => {
                            this.showUpload = !this.showUpload;

                        };
                        $mdDialog.show({
                            locals: {
                                title: modalTitle,
                                confirmationText: modalConfirmationText,
                                cancelText: modalCancelText,
                                confirmText: modalConfirmText,
                                itemCount1: itemCount1,
                                modalTypeOverride: modalTypeOverride,
                            },
                            controller: ($scope, $mdDialog) => {
                                $scope.cancel = () => {
                                    $mdDialog.hide();
                                };
                                $scope.confirm = () => {
                                    $scope.cancel();
                                    confirmActionFunc(this.appTemplate.id);
                                };
                            },
                            controllerAs: '$ctrl',
                            bindToController: true,
                            templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                            parent: angular.element('body'),
                            clickOutsideToClose: true,
                            escapeToClose: true,
                        });
                    } else {
                        this.showUpload = !this.showUpload;
                    }

                });

        };

        this.save = () => {
            if (this.appTemplate.id) {
                AppTemplate
                    .prototype$patchAttributes(
                        { id: this.appTemplate.id },
                        appStoreCustomAppSavePayload.buildAppTemplateUpdatePayload(this.appTemplate),
                    )
                    .$promise
                    .then(() => {
                        this.form.$setPristine();
                    })
                    .catch((error) => {
                        console.error(error);
                        Raven.captureException(error);
                    });
            } else {
                const subAccountId = Store.getCurrentSubAccountId();
                AppTemplate
                    .create(
                        appStoreCustomAppSavePayload.buildAppTemplateCreatePayload(this.appTemplate, subAccountId),
                    )
                    .$promise
                    .then(appTemplate => {
                        $state.go('root.app-store.custom-app-template-edit', { appTemplate, appTemplateId: appTemplate.id });
                    })
                    .catch((error) => {
                        console.error(error);
                        Raven.captureException(error);
                    });
            }
        };

        this.cancel = () => {
            $state.go('root.app-store');
        };

        this.refresh = () => {
            this.$onInit();
        };

        this.deleteById = ({ appTemplateId }) => {
            return AppTemplate
                .deleteById({ id: appTemplateId })
                .$promise
                .then((res) => {
                    return Store.removeSingleModelData('appTemplates', appTemplateId);
                })
                .then(() => {
                    $state.go('root.app-store');
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.findAppsUsingAppTemplateId = (appTemplateId) => {
            return App
                .find({
                    filter: {
                        where: { appTemplateId },
                        fields: ['id'],
                    },
                })
                .$promise;
        };

        this.delete = (appTemplateId) => {

            //find if app template used by any apps
            this.findAppsUsingAppTemplateId(appTemplateId)
                .then((response) => {
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    const appsUsedByTemplateCount = response && response.length;

                    //app exists
                    if (appsUsedByTemplateCount > 0) {
                        modalTitle = `You can't delete this template as it's used by ${appsUsedByTemplateCount} of your apps.`;
                        modalConfirmationText = 'Go to "My Apps" and delete the apps that are using this custom template.';
                        modalConfirmText = 'Go to My Apps';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = () => {
                            $state.go('root.my-apps');

                        };
                    } else {
                        modalTitle = 'Are you sure you want to permanently delete this template?';
                        modalConfirmText = 'Confirm';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (appTemplateId) => {
                            this.deleteById({ appTemplateId }).then($scope.cancel);
                        };
                    }
                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: modalCancelText,
                            confirmText: modalConfirmText,
                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };
                            $scope.confirm = () => {
                                $scope.cancel();
                                confirmActionFunc(appTemplateId);
                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });

                });

        };

        this.getUploadUrl = (file) => {
            const { token } = this.appTemplate;

            return $http({
                method: 'POST',
                url: `${this.SLS_URI}/custom-apps/upload`,
                data: { token },
            })
                .then(({ data }) => data);
        };

        this.success = () => {
            this.hideButton = false;
            this.upload = {
                title: 'Done',
                status: 'success',
                progress: 100,
            };
            this.getAppTemplate($stateParams.appTemplateId).then((appTemplate) => {
                this.appTemplate = Store.setSingleModelData('appTemplates', appTemplate.id, appTemplate);
                if (this.appTemplate.id && !this.appTemplate.version) {
                    this.showUpload = true;
                }
            });

        };

        this.error = () => {
            this.hideButton = false;
            this.upload = {
                title: 'Error',
                status: 'error',
            };
        };

        this.progress = (event) => {
            const { total, loaded } = event;
            const progress = 100 * loaded / total;
            this.upload.progress = progress;
        };

        this.upload = null;

        this.uploadZip = (files) => {
            const zip = files[0];
            if (!zip) return;
            this.showUpload = false;
            this.hideButton = true;

            this.getUploadUrl(zip)
                .then(({ url, accountId, appTemplateId }) => {
                    const headers = {
                        'Content-Type': 'application/zip',
                        'x-amz-meta-accountId': accountId,
                        'x-amz-meta-appTemplateId': appTemplateId,
                    };

                    this.upload = {
                        title: 'Uploading',
                        status: 'uploading',
                        progress: 0,
                    };

                    return Upload.http({
                        url,
                        method: 'PUT',
                        headers,
                        data: zip,
                    })
                        .then(this.unzip, this.error, this.progress);

                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.unzip = () => {
            this.upload = {
                title: 'Deploying',
                status: 'deploying',
            };
            const { token } = this.appTemplate;
            const options = {
                method: 'POST',
                url: `${this.SLS_URI}/custom-apps/unzip`,
                data: { token },
            };
            return $http(options)
                .then(this.success)
                .catch(this.error);
        };

        this.copyToClipboard = (text) => {
            ngCopy(text);
            this.copied = true;
            $timeout(() => {
                this.copied = false;
            }, 1000);

        };
    }

    module
        .config(function($stateProvider, $translatePartialLoaderProvider) {
            $stateProvider
                .state('root.app-store.custom-app-template-add', {
                    url: '/app-store/custom/add',
                    data: {
                        pageTitle: 'CUSTOM_TEMPLATE_ADD.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<custom-app-template-component></custom-app-template-component>',
                        },
                    },
                    params: {
                        route: { value: 'add' },
                    },
                    bodyClass: 'page--app-custom',
                })
                .state('root.app-store.custom-app-template-edit', {
                    url: '/app-store/custom/:appTemplateId',
                    data: {
                        pageTitle: 'APPS_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<custom-app-template-component></custom-app-template-component>',
                        },
                    },
                    params: {
                        route: { value: 'edit' },
                        appTemplateId: { value: null },
                    },
                });

            // Translations
            $translatePartialLoaderProvider.addPart('/js/app-store-custom-app');

        })
        .component('customAppTemplateComponent', {
            templateUrl: '/js/app-store-custom-app/app-store-custom-app.html',
            controller: CustomAppTemplateCtrl,
            bindings: {
                search: '<search',
            },
        });

})(angular.module('rocket.components'));
